/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/structural_template/canvas_template_cloned_steps_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementAppGroupIdStructuralTemplateCanvasTemplateClonedStepsData } from "./constants";
import type { CanvasStepDocument } from "../canvas/common";

export const getEngagementAppGroupIdStructuralTemplateCanvasTemplateClonedStepsData = reactQueryFetcherAdapter(
  engagementAppGroupIdStructuralTemplateCanvasTemplateClonedStepsData,
  (
    signal: AbortSignal,
    appGroupId: string,
    templateId: string,
    workflowId: string
  ): Promise<CanvasStepDocument[]> => {
    return fetch(
      `/engagement/${appGroupId}/structural_template/canvas_template_cloned_steps_data`,
      "GET",
      { template_id: templateId, workflow_id: workflowId },
      { signal }
    );
  }
);
